export default class SuppressionSummaryScheduler {
    constructor ( options = {} ) {
        this.now = options.now || Date.now;
        // Browser timers reject the scheduler as their receiver; call them as globals.
        this.setTimer = options.setTimer || ( ( callback, delay ) => setTimeout( callback, delay ) );
        this.clearTimer = options.clearTimer || ( timer => clearTimeout( timer ) );
        this.getActiveRateLimit = options.getActiveRateLimit;
        this.hasPending = options.hasPending;
        this.queueSummary = options.queueSummary;
        this.retryMs = options.retryMs;
        this.timer = null;
        this.scheduledAt = 0;
    }

    schedule ( requestedAt ) {
        if ( !this.hasPending() ) {
            return;
        }

        const now = this.now();
        const scheduledAt = Math.max( requestedAt || now + this.retryMs, now );

        if ( this.timer !== null && this.scheduledAt <= scheduledAt ) {
            return;
        }

        this.cancel();
        this.scheduledAt = scheduledAt;
        this.timer = this.setTimer( () => this.flush(), scheduledAt - now );
    }

    flush () {
        this.timer = null;
        this.scheduledAt = 0;

        if ( !this.hasPending() ) {
            return;
        }

        const activeRateLimit = this.getActiveRateLimit();
        if ( activeRateLimit ) {
            this.schedule( activeRateLimit.until );
            return;
        }

        this.queueSummary();

        // Sentry processes beforeSend asynchronously. Retain one bounded fallback
        // until that boundary accepts and drains the pending aggregate.
        if ( this.hasPending() ) {
            this.schedule( this.now() + this.retryMs );
        }
    }

    cancel () {
        if ( this.timer !== null ) {
            this.clearTimer( this.timer );
        }
        this.timer = null;
        this.scheduledAt = 0;
    }

    hasScheduledSummary () {
        return this.timer !== null;
    }
}
